// extracted by mini-css-extract-plugin
module.exports = {"section_form":"form_section_section_form__zw_TT"};